// extracted by mini-css-extract-plugin
export default {"image-grid-popover":"ImageGridPopover__image-grid-popover__vLSbg","imageGridPopover":"ImageGridPopover__image-grid-popover__vLSbg","fullscreen":"ImageGridPopover__fullscreen__XUMU4"};